export const NOT_FOUND_PAGE_LINK = '/404';
export const HOME_PAGE_LINK = '/';
export const MY_PROFILE_PAGE_LINK = '/my-profile';
export const USERS_PAGE_LINK = '/users';
export const ROLES_PAGE_LINK = '/roles';
export const TENANTS_PAGE_LINK = '/tenants';
export const LOGIN_LINK = `${process.env.REACT_APP_OAUTH_DOMAIN}/login`;
export const LOGOUT_LINK = `${process.env.REACT_APP_OAUTH_DOMAIN}/exit?redirect_url=${window.location.href}`;
export const AUTHORIZATION_URL = `${process.env.REACT_APP_OAUTH_DOMAIN}/oauth/authorize`;
export const GET_TOKEN_URL = `${process.env.REACT_APP_OAUTH_DOMAIN}/oauth/token`;
export const SIGN_UP_LINK = '/sign-up';
export const CLIENT_SIGN_UP_LINK = '/client-signup';
export const CLIENT_FORGOT_PASSWORD_LINK = '/client-forgot-password';
export const CLIENT_LOGIN_LINK = `${process.env.REACT_APP_OAUTH_DOMAIN}/client-login`;
export const FORGOT_PASSWORD_PAGE_LINK = '/forgot-password';
export const ACCOUNT_CHANGING_INFO_LINK = `${MY_PROFILE_PAGE_LINK}/change-info`;
export const ACCOUNT_CHANGING_PASSWORD_LINK = `${MY_PROFILE_PAGE_LINK}/change-password`;
export const RESET_PASSWORD_PAGE_LINK = '/reset-password';
export const CLIENT_RESET_PASSWORD_PAGE_LINK = '/client-reset-password';
export const REGISTER_NOTIFY_VERIFY_EMAIL_LINK = '/notify-verify-email';
export const CLIENT_REGISTER_NOTIFY_VERIFY_EMAIL_LINK = '/client-notify-verify-email';
